<template>
    <div v-if="loader">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-overlay :value="!loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Application Status</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <!-- <v-row justify="center">
          <v-col sm="3">
            <h3>Admission Application Status</h3>
          </v-col>
        </v-row> -->
                <v-row justify="center" class="ml-12">
                    <v-col sm="3">
                        <v-autocomplete dense rounded v-model="ay" item-value="id"
                            :items="application_status_data.academic_year_list" item-text="ay" label="Academic Year"
                            outlined></v-autocomplete>
                    </v-col>
                    <v-col sm="3">
                        <v-autocomplete dense rounded v-model="status"
                            :items="application_status_data.application_status_list" item-text="Application Status Data"
                            label="Application Status" outlined />
                    </v-col>
                    <v-col sm="3">
                        <v-autocomplete dense rounded v-model="std" :items="application_status_data.standard_list"
                            item-text="Application Status Data" label="Standard" outlined />
                    </v-col>
                    <v-col sm="3">
                        <v-autocomplete dense rounded v-model="application_percent" :items="application_status_percent"
                            item-text="percent" label="Percent Completed And Above" outlined />
                    </v-col>
                    <v-checkbox v-model="show" label="Show Range Wise Form">

                    </v-checkbox>
                    <v-col sm="3" v-if="show == true">
                        <v-text-field type="number" v-model="from_no"></v-text-field>
                    </v-col>
                    <v-col sm="3">
                        <v-text-field v-if="show == true" type="number" v-model="to_no"></v-text-field>
                    </v-col>
                    <v-col sm="3">
                        <v-btn class="button mb-0 mt-0" @click="getApplicationList"
                            :loading="fetch_btn_load">Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <br />
        <!-------------------------------- Notify to specific parent --------------------------------------------------->
        <v-form id="model" v-model="isValid1">
            <v-dialog v-model="dialog" max-width="500px">
                <v-card>
                    <v-card-title class="toolbar" md="6">Send Notification</v-card-title>
                    <!-- <v-card-subtitle md="6" >Email: test@gmail.com </v-card-subtitle> -->
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field label="Subject" placeholder="Enter subject for mail" outlined dense
                                    rounded clearable :required="true" v-model="subjectEmail" id="subjtxt"
                                    :rules="true ? [(v) => !!v || 'Field is required'] : []"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-textarea id="messagetxt" label="Body/SMS" dense rounded placeholder="Dear Parent...."
                                    v-model="bodySMSEmail" hint="Body for mail / Message for SMS" clearable
                                    :required="true" :rules="true ? [(v) => !!v || 'Field is required'] : []"
                                    outlined></v-textarea>
                            </v-col>
                            <v-col cols="6" md="6" sm="6" class="mt-0 pt-0">
                                <!-- <input type="checkbox" id="chksms" class="mr-2" value="SMS" v-model="checked_sms_email" @change="subjecttxtdisable()" label="SMS" />
                                <label for="SMS" class="mr-2" style="margin-top: -5px;">SMS</label> -->
                                <!-- <v-checkbox
        v-model="checked_sms_email"
        label="SMS"
        id="chksms"
        @change="subjecttxtdisable()"
        ></v-checkbox> -->
                                <input type="checkbox" class="mr-2" id="chkemail" value="Email"
                                    v-model="checked_sms_email" @change="enableTextBox()" label="Email" />
                                <label class="mr-2" for="email">Email</label>
                                <!-- <v-checkbox
        v-model="checked_sms_email"
        @change="enableTextBox()"
        label="Email"
        id="chkemail"
        ></v-checkbox> -->
                                <br />
                                <span v-if="checked_sms_email != ''"> {{ checked_sms_email }}</span>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="button" @click="dialog = false">Cancel</v-btn>
                        <v-btn class="button" @click="notifyParent()"
                            :color="isValid1 ? 'primary darken-1' : 'grey lighten-1'" :disabled="!isValid1">
                            Send
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-form>
        <!-------------------------------End of Notify to specific parent------------------------------------->

        <!-- Notify all ------------------------------>
        <div v-if="filtered_form_list">
            <div class="text-center">
                <v-form v-model="isValid">
                    <v-dialog v-model="noticeDialog" width="500">
                        <v-card>
                            <v-card-title class="toolbar" primary-title>Send Notification</v-card-title>

                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field label="Subject" placeholder="Enter subject for mail"
                                            v-model="subject" outlined dense rounded clearable :required="true"
                                            :rules="true ? [(v) => !!v || 'Field is required'] : []"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="12">
                                        <v-textarea dense rounded name="input-7-1" label="Body/SMS"
                                            placeholder="Dear Parent...." v-model="body"
                                            hint="Body for mail / Message for SMS" clearable :required="true"
                                            :rules="true ? [(v) => !!v || 'Field is required'] : []"
                                            outlined></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn class="button" @click="noticeDialog = false">Cancel</v-btn>
                                <v-btn class="button" :disabled="!isValid" @click="notifyAllParent">Send</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-form>
            </div>
            <!-- Notify all Ends---------------------------------------->
            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Admission Application Status Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                </v-toolbar>
                <div id="my-table-id">
                    <v-data-table :headers="headers" :items="bookList1" show-select item-key="id" v-model="selectedRows" sort-by class="elevation-1 mytable" dense
                        :search="search" @current-items="getFiltered">
                        <template v-slot:item.data-table-select="{ item, isSelected, select }">
                            <v-simple-checkbox
                            v-if="item.status !== 'Confirmed'"
                            :value="isSelected"
                            :disabled="item.status === 'Confirmed'"
                            @input="select($event)"
                            />
                        </template>
                        <template v-slot:top>
                            <v-toolbar flat dense color="white" align="center" justify="center">
                                <!-- <v-toolbar-title>Admission Application Status Details [Status: {{status}}]</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider> -->

                                <!-- <div style="width: 30px;"></div> -->
                                <!-- export btn -->
                                <v-col cols="12" sm="2" md="2" v-if="filtered_form_list.length != 0">
                                    <!-- <v-btn color="success" outlined rounded>
                                    <download-excel class="mr-2 pb-3 pt-2" :data="filtered_form_list" :fields="table_fields" worksheet="ApplicationStatus" name="ApplicationStatus.xls">
                                        <v-icon dark>mdi-file-excel</v-icon> Export
                                    </download-excel>
                                </v-btn> -->
                                    <v-btn class="mr-2 pb-3 pt-2 no-display" rounded color="success" outlined
                                        @click="fnExcelReport('my-table-id', 'ApplicationStatusListReport')"><v-icon
                                            color="success">mdi-export</v-icon>Export</v-btn>

                                </v-col>
                                <v-spacer></v-spacer>

                                <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                    hide-details></v-text-field>
                                <!-- <div style="width: 30px;"></div> -->
                                <v-btn class="button" @click="statusNotify">Notify to all</v-btn>
                            </v-toolbar>
                            <v-row justify="center" align="center">
                                <tr class="t-row mt-4 mb-2">
                                    <div>
                                        <th>
                                            <v-row>
                                                <span v-for="header in headers" :key="header.text">
                                                    <span v-if="filters.hasOwnProperty(header.value)">
                                                        <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small
                                                            rounded dense outlined color="#0F2027" :label="header.text"
                                                            multiple clearable :items="columnValueList(header.value)"
                                                            v-model="filters[header.value]"></v-autocomplete>
                                                    </span>
                                                </span>
                                            </v-row>
                                        </th>
                                    </div>
                                </tr>
                            </v-row>
                        </template>
                        <template v-slot:[`item.display_admission_form_no`]="{ item }">
                            <v-btn :disabled="!item.not_edit_admission_form" small class="button"
                                @click="viewForm(item.id, item.form_no,item.display_admission_form_no, item.standardName)">
                                <v-icon left>mdi-pencil</v-icon>
                                {{ item.display_admission_form_no }}
                            </v-btn>
                        </template>
                        <template v-slot:[`item.form_progess`]="{ item }">
                            <v-progress-circular :indeterminate="indeterminate" :rotate="rotate" size="40" class="ml-5"
                                :value="item.form_progess" width="4" :color="item.form_progess >= 0 && item.form_progess < 70
                                    ? 'red'
                                    : 'success'
                                    ">
                                {{ item.form_progess }}
                            </v-progress-circular>
                        </template>
                        <template v-slot:[`item.form_fees`]="{ item }">
                            <span v-if="item.form_fees == 0">
                                <v-btn class="ma-2" tile outlined color="primary" dark @click="payFormFees(item)">
                                    <v-icon left>mdi-currency-inr</v-icon> Pay Form Fees </v-btn>
                            </span>
                            <span v-else>
                                <v-btn class="ma-2" tile outlined color="success" dark @click="payFormFees(item)">
                                    <v-icon left>mdi-file-eye-outline</v-icon> {{ item.form_fees }} </v-btn>
                            </span>
                        </template>
                        <!-- <template v-slot:item.std="{ item }">
          <v-autocomplete
            dense
            v-model="item.std"
            class="mt-3"
            :items="all_std"
            item-text="std"
            label="Change Standard"
            outlined
          />
        </template>-->
                        <template v-slot:[`item.status`]="{ item }">
                            <v-autocomplete v-if="item.status != 'Confirmed'" rounded dense v-model="item.status" :items="all_status"
                                @change="changestatus(item)" :loading="status_btn_load" item-text="status" hide-details
                                label="Change Status" outlined />
                                <!-- <div v-if="item.status != 'Confirmed'"  style="color: #555;">
                                    <center><b style="font-size: 10px;">{{ item.status }}</b></center>
                                </div> -->
                                <div v-if="item.status == 'Confirmed'"  style="color: #555;">
                                    <center><b>{{ item.status }}</b></center>
                                </div>
                        </template>
                        <template v-slot:[`item.quota`]="{ item }">
                            <v-autocomplete v-if="item.status != 'Confirmed'" rounded dense v-model="item.quota" :items="quota_list"
                                @change="updatequota(item.id, item.quota)" return-object item-text="qname" hide-details
                                label="Change Quota" outlined />
                                <!-- <div style="color: #555;" v-if="item.status != 'Confirmed'">
                                    <center><b style="font-size: 10px;">{{ item.quota }}</b></center>
                                </div> -->
                                <div v-if="item.status == 'Confirmed'"  style="color: #555;">
                                    <center><b>{{ item.quota }}</b></center>
                                </div>
                        </template>

                        <template v-slot:[`item.remark`]="{ item }">
                            <v-text-field dense v-model="item.remark" class="mt-3" label="Remark" outlined />
                        </template>

                        <!-- dialog for send mail -->
                        <template v-slot:[`item.action`]="{ item }">
                            <div>
                                <v-btn class="button" icon @click="openNotifyParentDialog(item)" title="send email">
                                    <!-- <v-icon left>mdi-email-send-outline</v-icon> -->
                                    <v-icon>mdi-email-arrow-right-outline</v-icon>
                                </v-btn>
                            </div>
                        </template>
                        <template v-slot:[`item.view`]="{ item }">

                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <v-icon @click="viewApplicationForm(item)" style> mdi-eye </v-icon>
                                </template>
                                <span>View</span>
                            </v-tooltip>
                            <!-- </center>
                             <center v-else>
                                --
                             </center> -->
                        </template>
                    </v-data-table>
                </div>
                <div>
                    <v-row class="mt-2">
                        <v-col cols="3">
                            <v-autocomplete
                                v-model="bulkStatus"
                                :items="all_status"
                                item-text="status"
                                label="Change Status"
                                outlined dense
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-autocomplete
                                v-model="bulkQuota"
                                :items="quota_list"
                                item-text="qname"
                                label="Change Quota"
                                return-object
                                dense
                                outlined
                            />
                        </v-col>
                        <v-col cols="2">
                            <v-btn class="button" @click="checkIfMsgForBulk">
                                Apply
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
        </div>
        <v-dialog v-model="confirm_dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">
                    Are you sure you want to change status?
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="checkIfMsg(learner)">
                        Yes
                    </v-btn>
                    <v-btn color="red darken-1" text @click="confirm_dialog = false">
                        No
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dateAndTimeDialog" max-width="400">
            <v-card>
                <v-card-title class="toolbar" primary-title>
                    Select Date & Time for Parents to Visit
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="selectedDate"
                                    label="Select Date"
                                    type="date"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="selectedTime"
                                    label="Select Time"
                                    type="time"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-switch
                                    v-model="installmentApplicable"
                                    label="Is Installment Applicable?"
                                    inset
                                ></v-switch>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="justify-center">

                <v-btn color="brand" @click="saveDateTime">
                    Save
                </v-btn>
                <v-btn text color="grey" @click="dateAndTimeDialog = false;installmentApplicable = true;">
                    Cancel
                </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dateAndTimeDialogForBulk" max-width="400">
            <v-card>
                <v-card-title class="toolbar" primary-title>
                    Select Date & Time for Parents to Visit
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="selectedDate"
                                    label="Select Date"
                                    type="date"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="selectedTime"
                                    label="Select Time"
                                    type="time"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-switch
                                    v-model="installmentApplicable"
                                    label="Is Installment Applicable?"
                                    inset
                                ></v-switch>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="justify-center">

                    <v-btn color="brand" @click="saveDateTimeBulk">
                        Save
                    </v-btn>
                    <v-btn text color="grey" @click="dateAndTimeDialogForBulk = false;installmentApplicable = true;">
                        Cancel
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<!-- /dialog for send mail -->

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        selectedRows: [],
        bulkStatus: null,
        bulkQuota: null,
        chksms: true,
        enabledsms: false,
        messagetxt: true,
        // enabledemail: false,
        checked_sms_email: [],
        // extraBreadcrumbItems: [


        // ],
        // breadcrumbClass: "breadcrumb-style1",
        isValid: true,
        isValid1: true,
        dialog: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        loader: false,
        overlay: false,
        rotate: 0,
        subjectEmail: null,
        bodySMSEmail: null,
        individual_id: null,
        indeterminate: false,
        // academic_year_list: null,
        // application_status_list: null,
        // standard_list: null,
        //1
        application_status_data: "",
        status: null,
        ay: null,
        std: null,
        search: null,
        fetch_btn_load: false,
        //2
        filtered_form_list: null,
        quota_list: null,
        all_status: null,
        all_std: null,
        from_no: 1,
        to_no: 10,
        show: false,
        learner: null,
        confirm_dialog: false,
        filterArr: [],
        filters: {
            display_admission_form_no: [],
            quota: [],
            status: [],

        },
        headers: [
            { text: "Form No", value: "display_admission_form_no", sortable: true },
            { text: "Application Id", value: "application_id", sortable: true },
            { text: "Application Date", value: "app_date", sortable: true },
            { text: "Standard", value: "std", sortable: true },
            { text: "Name", value: "stud_name", sortable: true },
            { text: "DOB", value: "dob", sortable: true },
            { text: "Contact", value: "contact", sortable: true },
            { text: "Quota", value: "quota", sortable: true, width: 250},
            { text: "Status", value: "status", sortable: true,width: 250 },
            { text: "Progress", value: "form_progess", sortable: true },
            { text: "Type", value: "type", sortable: true },
            { text: "Mail Id", value: "father_email", sortable: true },
            { text: "View Form", value: "view", sortable: false },
            // {
            //   text: "Remark",
            //   value: "remark",
            //   sortable: false
            // },
            // { text: "Notify Applicant", value: "notify_action", sortable: false },
            { text: "Action", value: "action", sortable: false },
        ],
        table_fields: {
            "Form No": "form_no",
            "Application Date": "app_date",
            Standard: "std",
            Name: "stud_name",
            DOB: "dob",
            Contact: "contact",
            Quota: "quota",
            Status: "status",
            Progress: "form_progess",
            Type: "type",
        },
        //api-3
        status_btn_load: false,
        //api
        noticeDialog: false,
        subject: null,
        body: null,
        application_status_percent: [],
        application_percent: "",
        isMessageOnStatusChange: false,
        dateAndTimeDialog: false,
        dateAndTimeDialogForBulk: false,
        selectedDate: new Date().toISOString().substr(0, 10),
        selectedTime: new Date().toTimeString().slice(0, 5),
        installmentApplicable: true,
        date_time_applicable:false,
    }),
    computed: {
        bookList1() {
            return this.filtered_form_list.filter((d) => {
                return Object.keys(this.filters).every((f) => {
                    return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                });
            });
        },
    },
    methods: {
        viewApplicationForm(item) {


            if (this.org_id == "sbpps") {
                localStorage.setItem("setay", this.ay);
                if (item == null) {
                    localStorage.setItem("setform_id", item.id);
                } else {
                    localStorage.setItem("setform_id", item.id);
                }
                let routeData = this.$router.resolve({
                    name: "view-application-form-sbpps",
                });
                window.open(routeData.href, "_blank");
            } else {
                localStorage.setItem("admission-ay", this.ay);
                if (item == null) {
                    localStorage.setItem("admission_form_no", item.id);
                } else {
                    localStorage.setItem("admission_form_no", item.id);
                }
                let routeData = this.$router.resolve({ name: "parent-view-form" });
                window.open(routeData.href, "_blank");
            }
        },
        fnExcelReport(id, name) {
            let tab_text = `<table border='1px'>
    <tr>
      <th>Sr. No.</th>
      <th>Form No</th>
      <th>Application Date</th>
      <th>Standard</th>
      <th>Name</th>
      <th>DOB</th>
      <th>Contact</th>
      <th>Ouota</th>
      <th>Status</th>
      <th>Progress</th>
      <th>Type</th>
      <th>Mail Id</th>
      <th>Action</th>
   
      
    </tr>`;

            this.filtered_form_list.forEach((item, index) => {
                tab_text += `
    <tr>
            <td>${index + 1}</td>
            <td>${item.display_admission_form_no || ''}</td>
            <td>${item.app_date || ''}</td>
            <td>${item.std || ''}</td>
            <td>${item.stud_name || ''}</td>
            <td>${item.dob || ''}</td>
            <td>${item.contact || ''}</td>
            <td>${item.quota || ''}</td>
            <td>${item.status || ''}</td>
            <td>${item.form_progess || ''}</td>
            <td>${item.type || ''}</td>
            <td>${item.father_email || ''}</td>
            <td>${item.action || ''}</td>
        </tr>`;
            });

            tab_text += '</table>';

            const blob = new Blob([tab_text], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        updatequota(id, quota) {
            const formData = {
                form_id: id,
                quota: quota,
            };
            axios
                .post("/admission/updatequota", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        //alert()
                        this.showSnackbar("#4caf50", "Quota changed successfully"); // show snackbar
                        // this.getApplicationList();
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => { });
        },
        enableTextBox: function () {
            // console.log('inside enableTextBoxSMS');
            if (document.getElementById("chkemail").checked == true) {
                // document.getElementById("subjtxt").style.background="red" ;
                document.getElementById("subjtxt").disabled = false;
            } else if (document.getElementById("chkemail").checked == false) {
                //document.getElementById("subjtxt").style.background="green";
                document.getElementById("subjtxt").disabled = false;
                // document.getElementById("subjtxt").setAttribute("disabled", "true");
            }
        },
        subjecttxtdisable: function () {
            // console.log('inside subjecttxtdisable');
            if (document.getElementById("chksms").checked == true) {
                //document.getElementById("subjtxt").style.background="red";
                document.getElementById("subjtxt").disabled = true;
            } else if (document.getElementById("chksms").checked == false) {
                //document.getElementById("subjtxt").style.background="grey";
                document.getElementById("subjtxt").disabled = false;
            }
        },
        getFiltered(e) {
            this.filterArr = e;
        },
        columnValueList(val) {
            return this.filtered_form_list.map((d) => d[val]);
        },

        notifyAllParent() {
            const formData = {
                list: this.filtered_form_list,
                subject: this.subject,
                body: this.body,
            };
            axios
                .post("/admission/notifyAllParent", formData)
                .then((res) => {
                    if (res.data.msg == "200") {
                        if (res.data.status == "No") {
                            //alert()
                            this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
                        } else {
                            //alert("")
                            this.showSnackbar("#4caf50", "Notifying parent in background"); // show snackbar
                        }
                    } else {
                        //error
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.noticeDialog = false;
                    (this.subject = null), (this.body = null);
                });
        },
        statusNotify() {
            if (!confirm("Are You Sure You Want To Notify All....?")) return;
            if (this.filtered_form_list.length == 0) {
                alert("Empty list");
                return;
            }
            this.noticeDialog = true;
        },
        resetFields() {
            (this.subjectEmail = null), (this.bodySMSEmail = null), (this.checked_sms_email = null);
            this.checked_sms_email = [];
        },
        close() {
            this.dialog = false;
        },
        openNotifyParentDialog(item) {
            this.dialog = true;
            // console.log(item)
            this.individual_id = item.id;
        },
        notifyParent() {
            this.overlay = true;
            const data = {
                subject: this.subjectEmail,
                body: this.bodySMSEmail,
                mode: this.checked_sms_email,
                admission_form_id: this.individual_id,
            };
            // console.log(data)
            axios
                .post("/admission/sendEmailSMS", data)
                .then((res) => {
                    // console.log(res)
                    if (res.data.status.code == "SUCCESSSMS") {
                        this.showSnackbar("#4caf50", res.data.status.message); // show snackbar on success
                    } else if (res.data.status.code == "SUCCESSEMAIL") {
                        this.showSnackbar("#4caf50", res.data.status.message); // show snackbar on success
                    } else if (res.data.status.code == "SUCCESSBOTH") {
                        this.showSnackbar("#4caf50", res.data.status.message); // show snackbar on success
                    } else if (res.data.status.code == "NA") {
                        this.showSnackbar("#b71c1c", res.data.status.message); // show snackbar on success
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on success
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    this.status_btn_load = false;
                    this.overlay = false;
                    this.resetFields();
                });
            this.dialog = false;
            //  document.getElementById("messagetxt").value = "";
            // document.getElementById("subjtxt").value = "";
            // document.getElementById("model").text="";
            // document.getElementById("bodySMSEmail").reset();
            // document.getElementById("checked_sms_email").reset();
        },
        payFormFees(item) {
            const application_form_data = {
                admission_form_no: item.form_no,
                admission_form_id: item.id,
            };
            this.$store.commit("getformdata", application_form_data);
            // let route = this.$router.resolve({name: 'application-form-fees-staff'});
            // window.open(route.href, '_blank');
            this.$router.push({ name: "application-form-fees-staff" });
        },
        changestatus(formData) {
            this.learner = formData
            this.confirm_dialog = true
        },

        checkIfMsg(formData) {
            this.confirm_dialog = false;
            const currentLearner = this.learner;

            if ((formData.status == "Selected" || formData.status == "Interaction") && this.isMessageOnStatusChange) {
                if (this.date_time_applicable) {
                    const now = new Date();
                    currentLearner.date = now.toISOString().split("T")[0];
                    currentLearner.time = now.toTimeString().slice(0, 5);
                    currentLearner.is_installment_applicable = this.installmentApplicable;
                    
                    this.addLearner(currentLearner);
                    return;
                }
                this.dateAndTimeDialog = true;
                return;
            }
            
            currentLearner.is_installment_applicable = this.installmentApplicable;
            this.addLearner(currentLearner);
        },
        saveDateTime() {
            if (!this.selectedDate || !this.selectedTime) {
                this.showSnackbar("red", "Please select date and time");
                return;
            }

            this.learner.date = this.selectedDate;
            this.learner.time = this.selectedTime;
            this.learner.is_installment_applicable = this.installmentApplicable;

            this.dateAndTimeDialog = false;

            this.addLearner(this.learner);
            this.installmentApplicable = true;
        },

        addLearner(formData) {
            // alert("formData:"+formData.status)

            this.status_btn_load = true;
            axios
                .post("/admissionForm/addLearner", formData)
                .then((res) => {
                    if (res.data.msg == "200") {
                        if (res.data.status == "No") {
                            this.showSnackbar("red", res.data.status_reason);
                        }
                        // show snackbar
                        else this.showSnackbar("#4caf50", res.data.status_reason); // show snackbar
                    } else {
                        //error
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.status_btn_load = false;
                    // this.filtered_form_list = null;
                    // this.selectedDate = null;
                    // this.selectedTime = null;
                    // this.learner = null,
                    this.confirm_dialog = false;
                    this.installmentApplicable = true;
                    //this.getApplicationList();
                });
        },

        checkIfMsgForBulk(){
            if((this.bulkStatus == "Selected" || this.bulkStatus == "Interaction") 
                && this.isMessageOnStatusChange){

                if(this.date_time_applicable){
                    const now = new Date();
                    this.selectedDate = now.toISOString().split("T")[0];
                    this.selectedTime = now.toTimeString().slice(0,5);
                    this.applyBulkChanges();
                    return;
                }

                this.dateAndTimeDialogForBulk = true;
                return;
            }
            this.applyBulkChanges();
        },
        saveDateTimeBulk() {
            if (!this.selectedDate || !this.selectedTime) {
                this.showSnackbar("red", "Please select date and time");
                return;
            }
            this.dateAndTimeDialogForBulk = false;
            this.applyBulkChanges();
            this.installmentApplicable = true;
        },

        applyBulkChanges() {

            if (this.selectedRows.length === 0) {
                this.showSnackbar("#b71c1c","Please select rows");
                return;
            }

            const validRows = this.selectedRows.filter(r => r.status !== "Confirmed");

            if (validRows.length === 0) {
                this.showSnackbar("#b71c1c","Confirmed records cannot be updated");
                return;
            }

            // neither selected
            if (!this.bulkStatus && !this.bulkQuota) {
                this.showSnackbar("#b71c1c","Please select status or quota");
                return;
            }

            const payload = {
                ids: validRows.map(r => r.id),
                status: this.bulkStatus || null,
                quota: this.bulkQuota ? this.bulkQuota.qid : null,
                messageDate : this.selectedDate,
                messageTime : this.selectedTime,
                is_installment_applicable: this.installmentApplicable,
            };

            this.overlay = true;

            axios.post("/admissionForm/bulkUpdateStatusAndQuota", payload)
            .then(res => {

                if(res.data.msg == "200"){

                    this.showSnackbar("#4caf50","Updated successfully");

                    // update UI
                    validRows.forEach(row => {

                        if(this.bulkStatus)
                            row.status = this.bulkStatus;

                        if(this.bulkQuota)
                            row.quota = this.bulkQuota.qname;

                    });

                }

            })
            .finally(()=>{
                this.overlay = false
                this.selectedRows = []
                this.bulkStatus = null
                this.bulkQuota = null
                this.selectedDate = null;
                this.selectedTime = null;
                this.installmentApplicable = true;
            })

        },

        viewForm(id, form_no,display_admission_form_no, standardName) {
            const application_form_data = {
                admission_form_no: form_no,
                display_admission_form_no: display_admission_form_no,
                admission_form_id: id,
                standardName: standardName,
            };
            this.$store.commit("getformdata", application_form_data);
            this.$router.push("/role-dashboard/view-application-form");
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        init_call() {
            axios
                .post("/admission/applicationStatus")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.application_status_data = res.data.application_status_data;
                        this.application_status_data.application_status_list.unshift("All");
                        this.application_status_data.standard_list.unshift("All");
                        this.std = "All";
                        this.status = "All";
                        this.ay = this.application_status_data.academic_year_list[0].id;
                        this.application_status_percent = res.data.application_status_percent;
                        this.application_percent = this.application_status_percent[0].percent;
                        this.isMessageOnStatusChange = res.data.isMessageOnStatusChange;
                        this.date_time_applicable = res.data.date_time_applicable;
                        this.loader = true;
                    } else {
                        //error
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                });
        },
        getApplicationList() {
            if (this.ay == "" || this.ay == null) {
                this.showSnackbar("#b71c1c", "Please Select Academic Year..."); // show snackbar
                return
            }
            this.filtered_form_list = null;
            this.all_std = null;
            this.all_status = null;
            this.fetch_btn_load = true;

            localStorage.setItem("admission-ay", this.ay);

            const formData = {
                ay: this.ay,
                std: this.std,
                status: this.status,
                percent_completed: this.application_percent,
                from_no: this.from_no,
                to_no: this.to_no,
                show: this.show
            };
            axios
                .post("/admission/getApplicationList", formData)
                .then((res) => {
                    //console.log(res.data);
                    this.filtered_form_list = res.data.filtered_form_list;
                    this.all_std = res.data.all_std;
                    this.all_status = res.data.all_status;
                    this.quota_list = res.data.quota_list;
                    localStorage.setItem("filtered_form_list", JSON.stringify(this.filtered_form_list));
                    localStorage.setItem("all_std", JSON.stringify(this.all_std));
                    localStorage.setItem("all_status", JSON.stringify(this.all_status));
                    localStorage.setItem("quota_list", JSON.stringify(this.quota_list));
                    localStorage.setItem("form_fees_applicable", res.data.form_fees_applicable);
                    localStorage.setItem("allotmentApplicable",res.data.allotmentApplicable);
                    localStorage.setItem("Subject_Registration_Tab",res.data.Subject_Registration_Tab);
                    this.fetch_btn_load = false;
                    const isFormFeesApplicable = res.data.filtered_form_list.some(
                        item => item.form_fees_applicable
                    );

                    if (isFormFeesApplicable) {
                        if (!this.headers.some(head => head.value === "form_fees")) {
                            this.headers.splice(6, 0, {
                                text: "Form Fees",
                                value: "form_fees",
                                sortable: true,
                            });
                        }
                    }
                    // show snackbar on success
                    //console.log("res.data>>"+res.data)
                })
                .catch((error) => {
                    window.console.log(error);
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => {
                    //close loader
                    this.fetch_btn_load = false;
                });
        },
    },
    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },
    mounted() {
        this.init_call();

        const storedList = localStorage.getItem("filtered_form_list");
        const formFeesApplicable = localStorage.getItem("form_fees_applicable");
        if (storedList) {
            this.filtered_form_list = JSON.parse(storedList);
            // Only restore "Form Fees" column if it was applicable when data was saved
        if (formFeesApplicable === "true") { 
            if (!this.headers.some(h => h.value === "form_fees")) {
                this.headers.splice(6, 0, {
                    text: "Form Fees",
                    value: "form_fees",
                    sortable: true,
                });
            }
        } else {
            this.headers = this.headers.filter(h => h.value !== "form_fees");
        }
        }
        const quota_list_new = localStorage.getItem("quota_list");
        if (quota_list_new) {
            this.quota_list = JSON.parse(quota_list_new);
        }
        const all_status_new = localStorage.getItem("all_status");
        if (all_status_new) {
            this.all_status = JSON.parse(all_status_new);
        }
        const all_std_new = localStorage.getItem("all_std");
        if (all_std_new) {
            this.all_std = JSON.parse(all_std_new);
        }
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
#my-table-id {
    overflow-x: auto;
    display: block;
    width: 100%;
}
</style>
